/**
 * Module GameModelLocator
 * manager of GameItem classes and keeper of 'current game'
 *
 * Accessing just about any data from or property of a game is passed through this class
 * This class, as of right now, just sorta mixes itself into the GameDayCore object
 * It's not super kosher but it's one of the first classes I tried to move over from the 2 Gamedays so give me a break
 */
define('GameDayCore/GDControl/GameModelLocator/GameModelLocator',['require','exports','module','../../GDModel/GameItem/GameItem','gameday-index-enums/enums/baseball/GIDDecoder','extant/extant','../../GDUtil/window/Logg','../TfsManager/TfsManager','gameday-index-url-hasher/UrlHasher','../../GDUtil/dataMapping/GameReferenceNormalizer'],function(require,exports,module) {
    var GameItem = require("../../GDModel/GameItem/GameItem"),
        GameId = require("gameday-index-enums/enums/baseball/GIDDecoder"),
        exists = require("extant/extant"),
        logg = require("../../GDUtil/window/Logg"),
        TfsManager = require("../TfsManager/TfsManager"),
        UrlHasher = require("gameday-index-url-hasher/UrlHasher"),
		gidVals = require("../../GDUtil/dataMapping/GameReferenceNormalizer");

    var gameModels = [ ],
        currentGame;

	/**
	 * Function getGame
	 * @param gameID {String} game you want to Load
	 * @returns {GameItem}
	 *
	 * This delivers a GameItem object.
	 * If the game is already the 'current' (ie active) game, it just delivers that as if you called getCurrent()
	 * If the game exists but is idle, it activates the one requested and returns it
	 * If the game requested does not yet exist, it creates it and returns it
	 *
	 * In all cases if whatever game is current is not the one requested, it deactivates that game in favor of the new one
	 */
	exports.getGame = function(gameID) {
        var newGame,
            gameItemId;

		gameID = gidVals.storeVal(gameID);
		logg.log("get game by ID: " + gameID);

		// you give nothing, you get nothing
		if (!exists(gameID)) { 
            return null; 
        }
		// return the current game if that's what they asked for
		if (exists(currentGame) && exists(gameModels[gameID]) && gameID === currentGame.gameID) { 
            return currentGame; 
        }


		// stop the current game polling if we are requesting a new game
		if (exists(currentGame) && gameID !== currentGame.gameid) {
            // Shut em all down, in case of rapid switching
            for(gameItemId in gameModels){                
                if(gameModels[gameItemId].active()){
                    gameModels[gameItemId].stopHeartbeat();
                }
            }
		}

		// if there is not already a game for that id...
        newGame = gameModels[gameID];
        if(!exists(newGame)){
            logg.log("creating new game instance");

            newGame = new GameItem(gameID);
            gameModels[gameID] = newGame;
        }else{
            logg.log("game already exists");
        }
        // GameItems are smart... let them decide what to do
        currentGame = newGame;
        newGame.init();

  //       if (exists(currentGame) && currentGame.active() === false) {
  //           logg.log("starting game heartbeat...");
  //           currentGame.startHeartbeat();
  //       } else {
		// 	logg.log("that game was already a runnin'");
		// }

		return currentGame;
	};

    exports.retrieveGameFromCache =function(gameID){
        gameID = gidVals.storeVal(gameID);
        return gameModels[gameID];
    }
    /**
     * Function getCurrentGame
     * @returns {GameItem} can return null/undefined if there is no active game
     *
     * basic retreiver for the active game item
     */
    exports.getCurrentGame = function() {
        return currentGame;
    };

    /**
     * Function getGameData
     * @param flavor {*} Usually a string of what data you would like returned but also works with object or array or comma-separated string
     * @returns the the game model in whole or in part as delivered from the 'active' game
     */
    exports.getGameData = function(flavor) {
        if (exists(currentGame)) {
            return currentGame.getGameData(flavor);
        } else {
            return null;
        }
    };

    /**
     * Function requestGameData
     * @param flavor {*} Usually a string of what data you would like returned but also works with object or array or comma-separated string
     * @param params {Object} additional needed parameters to be mixed in for the Load path (eg Player ID)
     * @returns {String} a one-time unique event id that the requested data will be dispatched on
     *
     * initiates a request for a data Load that will result in an event under the returned unique event ID
     */
    exports.requestGameData = function(flavor, params) {
        var uniqueID = "update_ID:" + parseInt(Math.random() * 10000, 10);
        // var uniqueID = "update_ID:"+currentGame.gameID+":"+(flavor+"").replace(/,/g,':');
        if (exists(currentGame)) {
            currentGame.requestGameData(flavor, uniqueID, params);
        } else {
            logg.log("there was no game to get data from, so you will get nothing on this event id, ever.");
        }

        return uniqueID;

    };

    /**
     * Function switchGame
     * @param gid {String} game id to Load
     * @param startTimecode {String} any sort of timecode string from 2-6 characters with an option "et" for eastern time
     * @param tfsStart {Boolean} true for timecode advance, false for stay put
     *
     * hotswap game
     */
    exports.switchGame = function(gid, startTimecode, tfsStart) {
        var hashChange = { };

        if (TfsManager.syncActive()) { TfsManager.stopSync(); }

        if (exists(startTimecode)) {
            TfsManager.setTimerAdvanceOption(tfsStart);
            TfsManager.setTimecode(startTimecode);
            TfsManager.beginSync(true);
            hashChange.tfs = startTimecode;
        } else {
            TfsManager.setTimecode(undefined);
        }

        if (exists(gid)) {
            var gidVO = new GameId(gid);
            hashChange.game = gidVO.gid;
            exports.getGame(gidVO.gid_path);
        }

        UrlHasher.setHashParams(hashChange);
    };
});
